import React, { useState } from 'react';

/** A source's logo, or its initial when the file is missing (a provider with no logo in /public/sources). */
const SourceLogo: React.FC<{ slug: string; ext: string; name: string }> = ({ slug, ext, name }) => {
  const [failed, setFailed] = useState(false);
  if (!slug || failed) return <span className="c3-src-ini">{name.slice(0, 1)}</span>;
  return <img src={`/sources/${slug}.${ext}`} alt="" onError={() => setFailed(true)} />;
};

export default SourceLogo;
